import { useEffect, useState } from "react"

import HomeTab from "./UP_HomeTab"
import OrdersTab from "./UP_OrdersTab"
import SettingsTab from "./UP_SettingsTab"
import AddressPanel from "./UP_AddressTab"
import ListTab from "./UP_ListTab"

const UserPanelTabs = ({ tab, user, setTab }) => {
  if (tab === "home") {
    return <HomeTab user={user} setTab={setTab} />
  } else if (tab === "orders") {
    return <OrdersTab user={user} setTab={setTab} />
  } else if (tab === "address") {
    return <AddressPanel user={user} setTab={setTab} />
  } else if (tab === "lists") {
    return <ListTab user={user} setTab={setTab} />
  } else if (tab === "settings") {
    return <SettingsTab user={user} setTab={setTab} />
  } else {
    return <>No Tab Rendered</>
  }
}

export default UserPanelTabs
